<div class="innerBanner innerHeader">
    <div class="container md">
        <div class="viewerAssign">
            <div class="row">
                <div class="col-12 col-md-6">

                    <div class="backContent">
                        <a href="javascript:void(0);" class="backLink">Course Details</a>
                        <h2><i><svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12"
                                    fill="none">
                                    <path
                                        d="M6.57033 6.53033C6.86322 6.23744 6.86322 5.76256 6.57033 5.46967L1.79736 0.696699C1.50447 0.403806 1.02959 0.403806 0.736699 0.696699C0.443806 0.989593 0.443806 1.46447 0.736699 1.75736L4.97934 6L0.736699 10.2426C0.443806 10.5355 0.443806 11.0104 0.736699 11.3033C1.02959 11.5962 1.50447 11.5962 1.79736 11.3033L6.57033 6.53033ZM6 6.75H6.04V5.25H6V6.75Z"
                                        fill="black" fill-opacity="0.7" />
                                </svg></i>{{moduleName}}</h2>
                    </div>
                    <div class="viewerSubModule">
                        <div class="viewerSubTitle">
                            <span *ngIf="ModulSubData!=''">{{ModulSubData.submodule_name}} Introduction to Motor Engine
                                Rerouting</span>
                            <h2 *ngIf="ModulSubData!=''">{{ModulSubData.submodule_desc}}</h2>
                        </div>

                    </div>

                </div>
                <div class="col-12 col-md-6">
                    <!-- <div class="timerWrap countdown"> -->
                    <div class="timerWrap">
                        <ul *ngIf="getElapsedTime() as elapsed">
                            <li>
                                <div class="timer ">
                                    <span>{{elapsed.hours}}</span>
                                    <small>hrs</small>
                                </div>
                            </li>
                            <li>
                                <b>:</b>
                            </li>
                            <li>
                                <div class="timer">
                                    <span>{{elapsed.minutes}}</span>
                                    <small>min</small>
                                </div>
                            </li>
                            <li>
                                <b>:</b>
                            </li>
                            <li>
                                <div class="timer">
                                    <span>{{elapsed.seconds}}</span>
                                    <small>sec</small>
                                </div>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
<ngx-spinner>
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<div class="viewerQuestionWrapBg" *ngIf="isPassed ==3">
    <div class="p-0">

        <div class="viewerQuestionWrap">
            <div class="viewerQuestionHead"><b>Module Assessment</b><span>{{assQuestinData?.questions?.length}}
                    Questions</span></div>
            <div class="viewerQuestionMidil">
                <div class="viewerQuestionRepeat" *ngFor="let qustValues of assQuestinData.questions; let j = index">
                    <div class="questionWrap">
                        <div class="questionListWrap">
                            <h2>Question {{j+1}} <i *ngIf="qustValues.question_type==3">( drag and drop the correct
                                    option )</i></h2>
                            <h3>{{qustValues.question_text}}</h3>
                            <div><img src={{qustValues.question_asset_url}}></div>
                            <div *ngIf="qustValues.question_type==1">
                                <ul class="ausWrap">
                                    <li *ngFor="let responsesOp of qustValues.responses;let l=index;">
                                        <div class="questionUi" *ngIf="responsesOp.response != null">
                                            <!-- <input type="radio" name="question01"
                                                        (click)="putAns(l+1,responsesOp.response,1, qustValues)"> -->

                                            <input type="radio" name="question{{j+1}}" [value]="responsesOp.response"
                                                [(ngModel)]="selectedAnswers[j]" (change)="showSelectedAnswer(j)">
                                            <b>{{l+1}}</b>
                                            <span>{{responsesOp.response}}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div *ngIf="qustValues.question_type==2">
                                <ul class="ausWrap trueFalseClass">
                                    <li *ngFor="let responsesOp of qustValues.responses;let l=index;">
                                        <div class="questionUi" *ngIf="responsesOp.response != null">
                                            <!-- <input type="radio" id="l" name="question01"
                                                    (click)="putAns(l+1,responsesOp.response,2, qustValues)"> -->
                                            <input type="radio" name="question{{j+1}}" [value]="responsesOp.response"
                                                [(ngModel)]="selectedAnswers[j]" (change)="showSelectedAnswer(j)">
                                            <b>{{l+1}}</b>
                                            <span>{{responsesOp.response}}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="matchQuestion" *ngIf="qustValues.question_type == 3">
                                <!-- Display the responses -->
                                <ul class="ausWrap">
                                    <li *ngFor="let response of qustValues.responses; let i = index">
                                        <div class="questionUi">
                                            <input type="radio" name="question01" [value]="i">
                                            <b>{{i + 1}}</b>
                                            <span>{{response.response}}</span>
                                        </div>
                                    </li>
                                </ul>

                                <!-- Display the match responses with drag-and-drop -->
                                <ul class="ausWrap matchQuestionTags" cdkDropList
                                    (cdkDropListDropped)="drop($event, j, qustValues.responses)">
                                    <li *ngFor="let matchResponse of qustValues.match_responses; let i = index" cdkDrag
                                        [cdkDragData]="i">
                                        <div class="questionUi">
                                            <input type="radio" name="question01">
                                            <span>{{matchResponse.response_match}}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>


                        </div>
                    </div>

                </div>
                <!-- <button class="btn btn-primary takeass" *ngIf="assQuestinData.questions.length-1 == j"
                        [ngClass]=" (selectOption =='') ? ' btn btn-primary disable ':'btn btn-primary'"
                        (click)="assessmentsEvaluation(qustValues.assessment_id,qustValues.question_num,qustValues.assessment_question_id,j)">Submit For Evaluation</button> -->

                <!-- <button class="btn btn-primary"
                    [ngClass]=" (selectOption =='') ? ' btn btn-primary disable ':'btn btn-primary'">Submit For
                    Evaluation</button> -->

                <button [ngClass]=" (selectedAnswers =='') ? ' btn btn-primary disable ':'btn btn-primary'"
                    (click)="submitAnswers()">Submit</button>
                <!-- <button class="btn btn-primary" (click)="openSucessModel(sucessModel)">Sucess</button>
                <button class="btn btn-primary" (click)="openFailModel(failModel)">Fail</button>
                <button class="btn btn-primary" (click)="openSentModel(sentModel)">Sent</button> -->

            </div>
        </div>

    </div>
    <input type="hidden" (click)="open(multiloginValidation)" id="successMsg">
    <input type="hidden" (click)="openSucessModel(sucessModel)" id="successPopup">
    <input type="hidden" (click)="openFailModel(failModel)" id="failPopup">
</div>
<ng-template #multiloginValidation let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close"
                (click)="navigationEvent();modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <p class="size18">Please logout from other devices or login again to continue using the portal here</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="navigationEvent();modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">OK</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #sucessModel let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button> -->
            <div class="modal-area">
                <p class="modal-title">Congratulations!</p>

                <b class="imgWrap" *ngIf="courseStatus != 3"><img src="assets/images/img001.png" /></b>
                <b class="imgWrap" *ngIf="courseStatus == 3"><img src="assets/images/img001.png" /></b>
                <p class="content" *ngIf="courseStatus != 3">You have successfully cleared the assessment!
                    <span *ngIf="isLastSubmodule==0">You can now start the next sub module.</span>
                    <span *ngIf="isLastSubmodule==1">You can now start the module assessment.</span>
                </p>
                <p class="content" *ngIf="courseStatus == 3">You have successfully completed the course! You can now
                    download the course certificate.</p>
                    <p class="content">No of questions: {{this.EvaluationResults?.totalQuestion}} / Correct questions :                     {{this.EvaluationResults?.totalcorrectQsn}}</p>    
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">

                <!-- Temp Close <button *ngIf="this.EvaluationResults.is_passed == 1  && this.EvaluationResults.courseStatus!=3" class="btn btn-primary"
                    (click)="goViewer(this.EvaluationResults.module_id,this.EvaluationResults.submodule_id,courseId); modal.dismiss('Cross click')"
                    class="btn btn-primary btn-sm">Next Sub Module</button> -->
                <button *ngIf="this.EvaluationResults.is_passed == 1  && this.EvaluationResults.courseStatus!=3" class="btn btn-primary" [routerLink]="['/assigned_details_resume']" [queryParams]="{courseId:courseId}" (click)="modal.dismiss('Save click')" class="btn btn-primary btn-sm">Next Sub Module</button>

                <button *ngIf="this.EvaluationResults.is_passed == 1 && this.EvaluationResults.courseStatus!=3" [routerLink]="['/assigned_details_resume']" (click)="modal.dismiss('Save click')"
                    [queryParams]="{courseId:courseId}" class="btn btn-primary btn-sm">Back to course details</button>

                <button *ngIf="this.EvaluationResults.is_passed == 1 && this.EvaluationResults.courseStatus==3" class="btn btn-primary"
                    (click)="downloadCertificate()" class="btn btn-primary btn-sm">Download Certificate</button>

                <button *ngIf="this.EvaluationResults.is_passed == 1 && this.EvaluationResults.courseStatus ==3" [routerLink]="['/completed']" class="backPage" (click)="modal.dismiss('Save click')"
                    class="btn btn-primary btn-sm">Back to Home</button>

            </div>
        </div>
    </div>
</ng-template>

<ng-template #failModel let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button> -->
            <div class="modal-area">
                <p class="modal-title">Better luck next time!</p>

                <b class="imgWrap"><img src="assets/images/img003.png" /></b>

                <p *ngIf="3 - (this.EvaluationResults.attempt_num-1) != 0" class="content">You haven’t cleared the
                    assessment yet.<br />You have {{3 - (this.EvaluationResults.attempt_num-1)}} more attempts left to
                    pass this assessment.</p>

                <p *ngIf="3 - (this.EvaluationResults.attempt_num-1) == 0" class="content">You haven’t cleared the
                    assessment yet.<br />You have no more attempts left to pass this assessment.</p>
                <p class="content">No of questions: {{this.EvaluationResults?.totalQuestion}} / Correct questions :{{this.EvaluationResults?.totalcorrectQsn}}</p>    

                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">

                <button *ngIf="3-(this.EvaluationResults.attempt_num-1) !=0" [routerLink]="['/viewer-details']"
                    [queryParams]="{course_id:courseId, module_id:moduleId,submodule_id:submoduleId,assId:assId,AT:assessmentType}"
                    (click)="modal.dismiss('Cross click')" class="btn btn-primary btn-sm">Try again</button>

                <button *ngIf="3-(this.EvaluationResults.attempt_num-1)==0" (click)="openSentModel(sentModel)"
                    class="btn btn-primary btn-sm">Contact Admin</button>

                <button [routerLink]="['/assigned_details_resume']" [queryParams]="{courseId:courseId}"
                    class="btn btn-primary btn-sm" (click)="modal.dismiss('Cross click')">Back to course
                    details</button>

            </div>
        </div>
    </div>
</ng-template>

<ng-template #sentModel let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"> 
                <span aria-hidden="true">&times;</span>
            </button>-->
            <div class="modal-area">
                <p class="modal-title">REQUEST SENT TO ADMIN</p>

                <b class="imgWrap"><img src="assets/images/img002.png" /></b>
                <p class="content">Your request to increase the number of attempts<br />available for assessments, has
                    been sent to the admin<br />for review and approval.</p>
                <input type="hidden" (click)="closeModelPopup()" id="CloseIds">
                <a (click)="closeModelPopup()" class="btn-link">DONE</a>

            </div>
        </div>
    </div>
</ng-template>